import axios from 'axios'
import { Message } from 'element-ui'
import Vue from 'vue'
import store from '@/store'
import router from '@/router'

Vue.component(Message.name, Message)

axios.interceptors.request.use(config => {
  if (process.env.NODE_ENV === 'production') {
    // config.url = 'http://39.98.52.253:2' + config.url.replace(/^\/api/, '')
    // config.url = config.url.replace(/^\/api/, '')
  }
  // if (store.state.base.token) {
  //   config.headers.Authorization = `Bearer ${store.state.base.token}`
  // }
  return config
}, error => {
  return Promise.reject(error)
})

axios.interceptors.response.use(response => {
  return response
}, error => {
  if (error.response.status === 401) {
    store.commit('setLoading', false)
    router.replace({
      path: '/login'
    })
  }
  return Promise.resolve(error.response)
})

function checkStatus (response) {
  // loading
  // 如果http状态码正常，则直接返回数据
  if (response && (response.status === 200 || response.status === 304 || response.status === 400)) {
    return response
    // 如果不需要除了data之外的数据，可以直接 return response.data
  }
  // 异常状态下，把错误信息返回去
  return {
    status: -404,
    msg: '网络异常'
  }
}

function checkCode (res) {
  let rd = res.data
  // 如果code异常(这里已经包括网络错误，服务器错误，后端抛出的错误)，可以弹出一个错误提示，告诉用户
  if (res.status === -404) {
    // Message.error(res.msg)
  }
  if (rd.code === 1018) {
    // Message.error('登录失效，请重新登入')
    store.commit('setLoading', false)
    router.replace({
      path: '/login'
    })
  } else {
    if (rd.code && rd.code !== 1000) {
      Message.error(rd.message)
    }
  }
  return res
}

const $ajax = {
  post (url, data, formData) {
    return axios({
      method: 'post',
      url,
      data: data,
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(
      (response) => {
        return checkStatus(response)
      }
    ).then(
      (res) => {
        return checkCode(res)
      }
    )
  },
  get (url, params) {
    return axios({
      method: 'get',
      url,
      params,
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    }).then(
      (response) => {
        return checkStatus(response)
      }
    ).then(
      (res) => {
        return checkCode(res)
      }
    )
  },
  downLoad (url, params) {
    return axios({
      method: 'get',
      url,
      params,
      responseType: 'blob',
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    }).then(
      (response) => {
        return checkStatus(response)
      }
    ).then(
      (res) => {
        return checkCode(res)
      }
    )
  },
  put (url, params) {
    return axios({
      method: 'put',
      url,
      params,
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
      }
    }).then(
      (response) => {
        return checkStatus(response)
      }
    ).then(
      (res) => {
        return checkCode(res)
      }
    )
  },
  del (url, params) {
    return axios({
      method: 'delete',
      url,
      params,
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
      }
    }).then(
      (response) => {
        return checkStatus(response)
      }
    ).then(
      (res) => {
        return checkCode(res)
      }
    )
  }
}

// 请求地址 请求类型 请求参数 请求回调 请求返回就执行 请求错误 表单提交数据
export function api (url, method, data, callback, back, error, isFormData) {
  $ajax[method](url, data, isFormData).then(res => {
    // 如果是下载类型时
    if (method === 'downLoad') {
      let rHeader = res.headers['content-disposition']
      let fileName = decodeURI(rHeader ? rHeader.split('=')[1] : '')
      let blob = new Blob([res.data], { type: 'application/vnd.ms-excel' })
      let eLink = document.createElement('a')
      eLink.href = URL.createObjectURL(blob)
      eLink.download = fileName
      document.body.appendChild(eLink)
      eLink.click()
      document.body.removeChild(eLink)
      if (callback) {
        callback()
      }
    } else {
      // 返回码正确时返回数据
      if (res.data.code === 1000) {
        callback(res.data.data)
      } else {
        if (error) {
          error(res.data.data)
        }
      }
    }
    if (back) {
      back()
    }
  }).catch(err => {
    if (back) {
      back(err)
    }
  })
}



// WEBPACK FOOTER //
// ./src/http/index.js